export interface Manual {
  id: number
  type: string
  code?: string
}

export enum Manuals {
  Promo = 'PromoTypes',
  Budget = 'BudgetTypes',
  Mechanics = 'Mechanics',
  Condition = 'ConditionTypes',
}

export type UpdateManual = Omit<Manual, 'id'>

export interface UpdateManualParams {
  manual: Manual
  type: Manuals
  onSuccess?: VoidFunction
}

export interface RemoveManualParams {
  type: Manuals
  id: number
  onSuccess?: VoidFunction
}
